export const AIRLINE_ENGINEER_USER = 'AirlineEngineerUser'
export const IMPERSONATOR_USER = 'ImpersonatorUser'
export const WEB_USER = 'WebUser'
export const GUEST = 'Anon'